/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root"
import { Route as LoginRouteImport } from "./routes/login"
import { Route as AppRouteImport } from "./routes/app"
import { Route as AdminRouteImport } from "./routes/admin"
import { Route as IndexRouteImport } from "./routes/index"
import { Route as AppIndexRouteImport } from "./routes/app/index"
import { Route as AdminIndexRouteImport } from "./routes/admin/index"
import { Route as InviteTokenRouteImport } from "./routes/invite.$token"
import { Route as AuthCallbackRouteImport } from "./routes/auth.callback"
import { Route as AppAccountRouteImport } from "./routes/app/account"
import { Route as AdminUsersRouteImport } from "./routes/admin/users"
import { Route as AdminSweepsRouteImport } from "./routes/admin/sweeps"
import { Route as AdminPromosRouteImport } from "./routes/admin/promos"
import { Route as AdminPlansRouteImport } from "./routes/admin/plans"
import { Route as AdminPaymentsRouteImport } from "./routes/admin/payments"
import { Route as AdminIpBlocksRouteImport } from "./routes/admin/ip-blocks"
import { Route as AdminAuditRouteImport } from "./routes/admin/audit"
import { Route as AppAccountIndexRouteImport } from "./routes/app/account/index"
import { Route as SignupPayPaymentIdRouteImport } from "./routes/signup.pay.$paymentId"
import { Route as AppProjectsPidRouteImport } from "./routes/app/projects/$pid"
import { Route as AppAccountSessionsRouteImport } from "./routes/app/account/sessions"
import { Route as AdminUsersUidRouteImport } from "./routes/admin/users/$uid"
import { Route as AdminProjectsPidRouteImport } from "./routes/admin/projects/$pid"
import { Route as AppProjectsPidIndexRouteImport } from "./routes/app/projects/$pid/index"
import { Route as AppProjectsPidUsageRouteImport } from "./routes/app/projects/$pid/usage"
import { Route as AppProjectsPidSettingsRouteImport } from "./routes/app/projects/$pid/settings"
import { Route as AppProjectsPidPlanRouteImport } from "./routes/app/projects/$pid/plan"
import { Route as AppProjectsPidPaymentsRouteImport } from "./routes/app/projects/$pid/payments"
import { Route as AppProjectsPidMembersRouteImport } from "./routes/app/projects/$pid/members"
import { Route as AppProjectsPidKeysRouteImport } from "./routes/app/projects/$pid/keys"
import { Route as AppProjectsPidPayPaymentIdRouteImport } from "./routes/app/projects/$pid/pay.$paymentId"

const LoginRoute = LoginRouteImport.update({
  id: "/login",
  path: "/login",
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: "/app",
  path: "/app",
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: "/admin",
  path: "/admin",
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AppRoute,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AdminRoute,
} as any)
const InviteTokenRoute = InviteTokenRouteImport.update({
  id: "/invite/$token",
  path: "/invite/$token",
  getParentRoute: () => rootRouteImport,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: "/auth/callback",
  path: "/auth/callback",
  getParentRoute: () => rootRouteImport,
} as any)
const AppAccountRoute = AppAccountRouteImport.update({
  id: "/account",
  path: "/account",
  getParentRoute: () => AppRoute,
} as any)
const AdminUsersRoute = AdminUsersRouteImport.update({
  id: "/users",
  path: "/users",
  getParentRoute: () => AdminRoute,
} as any)
const AdminSweepsRoute = AdminSweepsRouteImport.update({
  id: "/sweeps",
  path: "/sweeps",
  getParentRoute: () => AdminRoute,
} as any)
const AdminPromosRoute = AdminPromosRouteImport.update({
  id: "/promos",
  path: "/promos",
  getParentRoute: () => AdminRoute,
} as any)
const AdminPlansRoute = AdminPlansRouteImport.update({
  id: "/plans",
  path: "/plans",
  getParentRoute: () => AdminRoute,
} as any)
const AdminPaymentsRoute = AdminPaymentsRouteImport.update({
  id: "/payments",
  path: "/payments",
  getParentRoute: () => AdminRoute,
} as any)
const AdminIpBlocksRoute = AdminIpBlocksRouteImport.update({
  id: "/ip-blocks",
  path: "/ip-blocks",
  getParentRoute: () => AdminRoute,
} as any)
const AdminAuditRoute = AdminAuditRouteImport.update({
  id: "/audit",
  path: "/audit",
  getParentRoute: () => AdminRoute,
} as any)
const AppAccountIndexRoute = AppAccountIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AppAccountRoute,
} as any)
const SignupPayPaymentIdRoute = SignupPayPaymentIdRouteImport.update({
  id: "/signup/pay/$paymentId",
  path: "/signup/pay/$paymentId",
  getParentRoute: () => rootRouteImport,
} as any)
const AppProjectsPidRoute = AppProjectsPidRouteImport.update({
  id: "/projects/$pid",
  path: "/projects/$pid",
  getParentRoute: () => AppRoute,
} as any)
const AppAccountSessionsRoute = AppAccountSessionsRouteImport.update({
  id: "/sessions",
  path: "/sessions",
  getParentRoute: () => AppAccountRoute,
} as any)
const AdminUsersUidRoute = AdminUsersUidRouteImport.update({
  id: "/$uid",
  path: "/$uid",
  getParentRoute: () => AdminUsersRoute,
} as any)
const AdminProjectsPidRoute = AdminProjectsPidRouteImport.update({
  id: "/projects/$pid",
  path: "/projects/$pid",
  getParentRoute: () => AdminRoute,
} as any)
const AppProjectsPidIndexRoute = AppProjectsPidIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AppProjectsPidRoute,
} as any)
const AppProjectsPidUsageRoute = AppProjectsPidUsageRouteImport.update({
  id: "/usage",
  path: "/usage",
  getParentRoute: () => AppProjectsPidRoute,
} as any).lazy(() =>
  import("./routes/app/projects/$pid/usage.lazy").then((d) => d.Route),
)
const AppProjectsPidSettingsRoute = AppProjectsPidSettingsRouteImport.update({
  id: "/settings",
  path: "/settings",
  getParentRoute: () => AppProjectsPidRoute,
} as any)
const AppProjectsPidPlanRoute = AppProjectsPidPlanRouteImport.update({
  id: "/plan",
  path: "/plan",
  getParentRoute: () => AppProjectsPidRoute,
} as any)
const AppProjectsPidPaymentsRoute = AppProjectsPidPaymentsRouteImport.update({
  id: "/payments",
  path: "/payments",
  getParentRoute: () => AppProjectsPidRoute,
} as any)
const AppProjectsPidMembersRoute = AppProjectsPidMembersRouteImport.update({
  id: "/members",
  path: "/members",
  getParentRoute: () => AppProjectsPidRoute,
} as any)
const AppProjectsPidKeysRoute = AppProjectsPidKeysRouteImport.update({
  id: "/keys",
  path: "/keys",
  getParentRoute: () => AppProjectsPidRoute,
} as any)
const AppProjectsPidPayPaymentIdRoute =
  AppProjectsPidPayPaymentIdRouteImport.update({
    id: "/pay/$paymentId",
    path: "/pay/$paymentId",
    getParentRoute: () => AppProjectsPidRoute,
  } as any)

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute
  "/admin": typeof AdminRouteWithChildren
  "/app": typeof AppRouteWithChildren
  "/login": typeof LoginRoute
  "/admin/audit": typeof AdminAuditRoute
  "/admin/ip-blocks": typeof AdminIpBlocksRoute
  "/admin/payments": typeof AdminPaymentsRoute
  "/admin/plans": typeof AdminPlansRoute
  "/admin/promos": typeof AdminPromosRoute
  "/admin/sweeps": typeof AdminSweepsRoute
  "/admin/users": typeof AdminUsersRouteWithChildren
  "/app/account": typeof AppAccountRouteWithChildren
  "/auth/callback": typeof AuthCallbackRoute
  "/invite/$token": typeof InviteTokenRoute
  "/admin/": typeof AdminIndexRoute
  "/app/": typeof AppIndexRoute
  "/admin/projects/$pid": typeof AdminProjectsPidRoute
  "/admin/users/$uid": typeof AdminUsersUidRoute
  "/app/account/sessions": typeof AppAccountSessionsRoute
  "/app/projects/$pid": typeof AppProjectsPidRouteWithChildren
  "/signup/pay/$paymentId": typeof SignupPayPaymentIdRoute
  "/app/account/": typeof AppAccountIndexRoute
  "/app/projects/$pid/keys": typeof AppProjectsPidKeysRoute
  "/app/projects/$pid/members": typeof AppProjectsPidMembersRoute
  "/app/projects/$pid/payments": typeof AppProjectsPidPaymentsRoute
  "/app/projects/$pid/plan": typeof AppProjectsPidPlanRoute
  "/app/projects/$pid/settings": typeof AppProjectsPidSettingsRoute
  "/app/projects/$pid/usage": typeof AppProjectsPidUsageRoute
  "/app/projects/$pid/": typeof AppProjectsPidIndexRoute
  "/app/projects/$pid/pay/$paymentId": typeof AppProjectsPidPayPaymentIdRoute
}
export interface FileRoutesByTo {
  "/": typeof IndexRoute
  "/login": typeof LoginRoute
  "/admin/audit": typeof AdminAuditRoute
  "/admin/ip-blocks": typeof AdminIpBlocksRoute
  "/admin/payments": typeof AdminPaymentsRoute
  "/admin/plans": typeof AdminPlansRoute
  "/admin/promos": typeof AdminPromosRoute
  "/admin/sweeps": typeof AdminSweepsRoute
  "/admin/users": typeof AdminUsersRouteWithChildren
  "/auth/callback": typeof AuthCallbackRoute
  "/invite/$token": typeof InviteTokenRoute
  "/admin": typeof AdminIndexRoute
  "/app": typeof AppIndexRoute
  "/admin/projects/$pid": typeof AdminProjectsPidRoute
  "/admin/users/$uid": typeof AdminUsersUidRoute
  "/app/account/sessions": typeof AppAccountSessionsRoute
  "/signup/pay/$paymentId": typeof SignupPayPaymentIdRoute
  "/app/account": typeof AppAccountIndexRoute
  "/app/projects/$pid/keys": typeof AppProjectsPidKeysRoute
  "/app/projects/$pid/members": typeof AppProjectsPidMembersRoute
  "/app/projects/$pid/payments": typeof AppProjectsPidPaymentsRoute
  "/app/projects/$pid/plan": typeof AppProjectsPidPlanRoute
  "/app/projects/$pid/settings": typeof AppProjectsPidSettingsRoute
  "/app/projects/$pid/usage": typeof AppProjectsPidUsageRoute
  "/app/projects/$pid": typeof AppProjectsPidIndexRoute
  "/app/projects/$pid/pay/$paymentId": typeof AppProjectsPidPayPaymentIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  "/": typeof IndexRoute
  "/admin": typeof AdminRouteWithChildren
  "/app": typeof AppRouteWithChildren
  "/login": typeof LoginRoute
  "/admin/audit": typeof AdminAuditRoute
  "/admin/ip-blocks": typeof AdminIpBlocksRoute
  "/admin/payments": typeof AdminPaymentsRoute
  "/admin/plans": typeof AdminPlansRoute
  "/admin/promos": typeof AdminPromosRoute
  "/admin/sweeps": typeof AdminSweepsRoute
  "/admin/users": typeof AdminUsersRouteWithChildren
  "/app/account": typeof AppAccountRouteWithChildren
  "/auth/callback": typeof AuthCallbackRoute
  "/invite/$token": typeof InviteTokenRoute
  "/admin/": typeof AdminIndexRoute
  "/app/": typeof AppIndexRoute
  "/admin/projects/$pid": typeof AdminProjectsPidRoute
  "/admin/users/$uid": typeof AdminUsersUidRoute
  "/app/account/sessions": typeof AppAccountSessionsRoute
  "/app/projects/$pid": typeof AppProjectsPidRouteWithChildren
  "/signup/pay/$paymentId": typeof SignupPayPaymentIdRoute
  "/app/account/": typeof AppAccountIndexRoute
  "/app/projects/$pid/keys": typeof AppProjectsPidKeysRoute
  "/app/projects/$pid/members": typeof AppProjectsPidMembersRoute
  "/app/projects/$pid/payments": typeof AppProjectsPidPaymentsRoute
  "/app/projects/$pid/plan": typeof AppProjectsPidPlanRoute
  "/app/projects/$pid/settings": typeof AppProjectsPidSettingsRoute
  "/app/projects/$pid/usage": typeof AppProjectsPidUsageRoute
  "/app/projects/$pid/": typeof AppProjectsPidIndexRoute
  "/app/projects/$pid/pay/$paymentId": typeof AppProjectsPidPayPaymentIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | "/"
    | "/admin"
    | "/app"
    | "/login"
    | "/admin/audit"
    | "/admin/ip-blocks"
    | "/admin/payments"
    | "/admin/plans"
    | "/admin/promos"
    | "/admin/sweeps"
    | "/admin/users"
    | "/app/account"
    | "/auth/callback"
    | "/invite/$token"
    | "/admin/"
    | "/app/"
    | "/admin/projects/$pid"
    | "/admin/users/$uid"
    | "/app/account/sessions"
    | "/app/projects/$pid"
    | "/signup/pay/$paymentId"
    | "/app/account/"
    | "/app/projects/$pid/keys"
    | "/app/projects/$pid/members"
    | "/app/projects/$pid/payments"
    | "/app/projects/$pid/plan"
    | "/app/projects/$pid/settings"
    | "/app/projects/$pid/usage"
    | "/app/projects/$pid/"
    | "/app/projects/$pid/pay/$paymentId"
  fileRoutesByTo: FileRoutesByTo
  to:
    | "/"
    | "/login"
    | "/admin/audit"
    | "/admin/ip-blocks"
    | "/admin/payments"
    | "/admin/plans"
    | "/admin/promos"
    | "/admin/sweeps"
    | "/admin/users"
    | "/auth/callback"
    | "/invite/$token"
    | "/admin"
    | "/app"
    | "/admin/projects/$pid"
    | "/admin/users/$uid"
    | "/app/account/sessions"
    | "/signup/pay/$paymentId"
    | "/app/account"
    | "/app/projects/$pid/keys"
    | "/app/projects/$pid/members"
    | "/app/projects/$pid/payments"
    | "/app/projects/$pid/plan"
    | "/app/projects/$pid/settings"
    | "/app/projects/$pid/usage"
    | "/app/projects/$pid"
    | "/app/projects/$pid/pay/$paymentId"
  id:
    | "__root__"
    | "/"
    | "/admin"
    | "/app"
    | "/login"
    | "/admin/audit"
    | "/admin/ip-blocks"
    | "/admin/payments"
    | "/admin/plans"
    | "/admin/promos"
    | "/admin/sweeps"
    | "/admin/users"
    | "/app/account"
    | "/auth/callback"
    | "/invite/$token"
    | "/admin/"
    | "/app/"
    | "/admin/projects/$pid"
    | "/admin/users/$uid"
    | "/app/account/sessions"
    | "/app/projects/$pid"
    | "/signup/pay/$paymentId"
    | "/app/account/"
    | "/app/projects/$pid/keys"
    | "/app/projects/$pid/members"
    | "/app/projects/$pid/payments"
    | "/app/projects/$pid/plan"
    | "/app/projects/$pid/settings"
    | "/app/projects/$pid/usage"
    | "/app/projects/$pid/"
    | "/app/projects/$pid/pay/$paymentId"
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRoute: typeof AdminRouteWithChildren
  AppRoute: typeof AppRouteWithChildren
  LoginRoute: typeof LoginRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
  InviteTokenRoute: typeof InviteTokenRoute
  SignupPayPaymentIdRoute: typeof SignupPayPaymentIdRoute
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/login": {
      id: "/login"
      path: "/login"
      fullPath: "/login"
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/app": {
      id: "/app"
      path: "/app"
      fullPath: "/app"
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin": {
      id: "/admin"
      path: "/admin"
      fullPath: "/admin"
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/": {
      id: "/"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/app/": {
      id: "/app/"
      path: "/"
      fullPath: "/app/"
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    "/admin/": {
      id: "/admin/"
      path: "/"
      fullPath: "/admin/"
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    "/invite/$token": {
      id: "/invite/$token"
      path: "/invite/$token"
      fullPath: "/invite/$token"
      preLoaderRoute: typeof InviteTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/auth/callback": {
      id: "/auth/callback"
      path: "/auth/callback"
      fullPath: "/auth/callback"
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/app/account": {
      id: "/app/account"
      path: "/account"
      fullPath: "/app/account"
      preLoaderRoute: typeof AppAccountRouteImport
      parentRoute: typeof AppRoute
    }
    "/admin/users": {
      id: "/admin/users"
      path: "/users"
      fullPath: "/admin/users"
      preLoaderRoute: typeof AdminUsersRouteImport
      parentRoute: typeof AdminRoute
    }
    "/admin/sweeps": {
      id: "/admin/sweeps"
      path: "/sweeps"
      fullPath: "/admin/sweeps"
      preLoaderRoute: typeof AdminSweepsRouteImport
      parentRoute: typeof AdminRoute
    }
    "/admin/promos": {
      id: "/admin/promos"
      path: "/promos"
      fullPath: "/admin/promos"
      preLoaderRoute: typeof AdminPromosRouteImport
      parentRoute: typeof AdminRoute
    }
    "/admin/plans": {
      id: "/admin/plans"
      path: "/plans"
      fullPath: "/admin/plans"
      preLoaderRoute: typeof AdminPlansRouteImport
      parentRoute: typeof AdminRoute
    }
    "/admin/payments": {
      id: "/admin/payments"
      path: "/payments"
      fullPath: "/admin/payments"
      preLoaderRoute: typeof AdminPaymentsRouteImport
      parentRoute: typeof AdminRoute
    }
    "/admin/ip-blocks": {
      id: "/admin/ip-blocks"
      path: "/ip-blocks"
      fullPath: "/admin/ip-blocks"
      preLoaderRoute: typeof AdminIpBlocksRouteImport
      parentRoute: typeof AdminRoute
    }
    "/admin/audit": {
      id: "/admin/audit"
      path: "/audit"
      fullPath: "/admin/audit"
      preLoaderRoute: typeof AdminAuditRouteImport
      parentRoute: typeof AdminRoute
    }
    "/app/account/": {
      id: "/app/account/"
      path: "/"
      fullPath: "/app/account/"
      preLoaderRoute: typeof AppAccountIndexRouteImport
      parentRoute: typeof AppAccountRoute
    }
    "/signup/pay/$paymentId": {
      id: "/signup/pay/$paymentId"
      path: "/signup/pay/$paymentId"
      fullPath: "/signup/pay/$paymentId"
      preLoaderRoute: typeof SignupPayPaymentIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/app/projects/$pid": {
      id: "/app/projects/$pid"
      path: "/projects/$pid"
      fullPath: "/app/projects/$pid"
      preLoaderRoute: typeof AppProjectsPidRouteImport
      parentRoute: typeof AppRoute
    }
    "/app/account/sessions": {
      id: "/app/account/sessions"
      path: "/sessions"
      fullPath: "/app/account/sessions"
      preLoaderRoute: typeof AppAccountSessionsRouteImport
      parentRoute: typeof AppAccountRoute
    }
    "/admin/users/$uid": {
      id: "/admin/users/$uid"
      path: "/$uid"
      fullPath: "/admin/users/$uid"
      preLoaderRoute: typeof AdminUsersUidRouteImport
      parentRoute: typeof AdminUsersRoute
    }
    "/admin/projects/$pid": {
      id: "/admin/projects/$pid"
      path: "/projects/$pid"
      fullPath: "/admin/projects/$pid"
      preLoaderRoute: typeof AdminProjectsPidRouteImport
      parentRoute: typeof AdminRoute
    }
    "/app/projects/$pid/": {
      id: "/app/projects/$pid/"
      path: "/"
      fullPath: "/app/projects/$pid/"
      preLoaderRoute: typeof AppProjectsPidIndexRouteImport
      parentRoute: typeof AppProjectsPidRoute
    }
    "/app/projects/$pid/usage": {
      id: "/app/projects/$pid/usage"
      path: "/usage"
      fullPath: "/app/projects/$pid/usage"
      preLoaderRoute: typeof AppProjectsPidUsageRouteImport
      parentRoute: typeof AppProjectsPidRoute
    }
    "/app/projects/$pid/settings": {
      id: "/app/projects/$pid/settings"
      path: "/settings"
      fullPath: "/app/projects/$pid/settings"
      preLoaderRoute: typeof AppProjectsPidSettingsRouteImport
      parentRoute: typeof AppProjectsPidRoute
    }
    "/app/projects/$pid/plan": {
      id: "/app/projects/$pid/plan"
      path: "/plan"
      fullPath: "/app/projects/$pid/plan"
      preLoaderRoute: typeof AppProjectsPidPlanRouteImport
      parentRoute: typeof AppProjectsPidRoute
    }
    "/app/projects/$pid/payments": {
      id: "/app/projects/$pid/payments"
      path: "/payments"
      fullPath: "/app/projects/$pid/payments"
      preLoaderRoute: typeof AppProjectsPidPaymentsRouteImport
      parentRoute: typeof AppProjectsPidRoute
    }
    "/app/projects/$pid/members": {
      id: "/app/projects/$pid/members"
      path: "/members"
      fullPath: "/app/projects/$pid/members"
      preLoaderRoute: typeof AppProjectsPidMembersRouteImport
      parentRoute: typeof AppProjectsPidRoute
    }
    "/app/projects/$pid/keys": {
      id: "/app/projects/$pid/keys"
      path: "/keys"
      fullPath: "/app/projects/$pid/keys"
      preLoaderRoute: typeof AppProjectsPidKeysRouteImport
      parentRoute: typeof AppProjectsPidRoute
    }
    "/app/projects/$pid/pay/$paymentId": {
      id: "/app/projects/$pid/pay/$paymentId"
      path: "/pay/$paymentId"
      fullPath: "/app/projects/$pid/pay/$paymentId"
      preLoaderRoute: typeof AppProjectsPidPayPaymentIdRouteImport
      parentRoute: typeof AppProjectsPidRoute
    }
  }
}

interface AdminUsersRouteChildren {
  AdminUsersUidRoute: typeof AdminUsersUidRoute
}

const AdminUsersRouteChildren: AdminUsersRouteChildren = {
  AdminUsersUidRoute: AdminUsersUidRoute,
}

const AdminUsersRouteWithChildren = AdminUsersRoute._addFileChildren(
  AdminUsersRouteChildren,
)

interface AdminRouteChildren {
  AdminAuditRoute: typeof AdminAuditRoute
  AdminIpBlocksRoute: typeof AdminIpBlocksRoute
  AdminPaymentsRoute: typeof AdminPaymentsRoute
  AdminPlansRoute: typeof AdminPlansRoute
  AdminPromosRoute: typeof AdminPromosRoute
  AdminSweepsRoute: typeof AdminSweepsRoute
  AdminUsersRoute: typeof AdminUsersRouteWithChildren
  AdminIndexRoute: typeof AdminIndexRoute
  AdminProjectsPidRoute: typeof AdminProjectsPidRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminAuditRoute: AdminAuditRoute,
  AdminIpBlocksRoute: AdminIpBlocksRoute,
  AdminPaymentsRoute: AdminPaymentsRoute,
  AdminPlansRoute: AdminPlansRoute,
  AdminPromosRoute: AdminPromosRoute,
  AdminSweepsRoute: AdminSweepsRoute,
  AdminUsersRoute: AdminUsersRouteWithChildren,
  AdminIndexRoute: AdminIndexRoute,
  AdminProjectsPidRoute: AdminProjectsPidRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

interface AppAccountRouteChildren {
  AppAccountSessionsRoute: typeof AppAccountSessionsRoute
  AppAccountIndexRoute: typeof AppAccountIndexRoute
}

const AppAccountRouteChildren: AppAccountRouteChildren = {
  AppAccountSessionsRoute: AppAccountSessionsRoute,
  AppAccountIndexRoute: AppAccountIndexRoute,
}

const AppAccountRouteWithChildren = AppAccountRoute._addFileChildren(
  AppAccountRouteChildren,
)

interface AppProjectsPidRouteChildren {
  AppProjectsPidKeysRoute: typeof AppProjectsPidKeysRoute
  AppProjectsPidMembersRoute: typeof AppProjectsPidMembersRoute
  AppProjectsPidPaymentsRoute: typeof AppProjectsPidPaymentsRoute
  AppProjectsPidPlanRoute: typeof AppProjectsPidPlanRoute
  AppProjectsPidSettingsRoute: typeof AppProjectsPidSettingsRoute
  AppProjectsPidUsageRoute: typeof AppProjectsPidUsageRoute
  AppProjectsPidIndexRoute: typeof AppProjectsPidIndexRoute
  AppProjectsPidPayPaymentIdRoute: typeof AppProjectsPidPayPaymentIdRoute
}

const AppProjectsPidRouteChildren: AppProjectsPidRouteChildren = {
  AppProjectsPidKeysRoute: AppProjectsPidKeysRoute,
  AppProjectsPidMembersRoute: AppProjectsPidMembersRoute,
  AppProjectsPidPaymentsRoute: AppProjectsPidPaymentsRoute,
  AppProjectsPidPlanRoute: AppProjectsPidPlanRoute,
  AppProjectsPidSettingsRoute: AppProjectsPidSettingsRoute,
  AppProjectsPidUsageRoute: AppProjectsPidUsageRoute,
  AppProjectsPidIndexRoute: AppProjectsPidIndexRoute,
  AppProjectsPidPayPaymentIdRoute: AppProjectsPidPayPaymentIdRoute,
}

const AppProjectsPidRouteWithChildren = AppProjectsPidRoute._addFileChildren(
  AppProjectsPidRouteChildren,
)

interface AppRouteChildren {
  AppAccountRoute: typeof AppAccountRouteWithChildren
  AppIndexRoute: typeof AppIndexRoute
  AppProjectsPidRoute: typeof AppProjectsPidRouteWithChildren
}

const AppRouteChildren: AppRouteChildren = {
  AppAccountRoute: AppAccountRouteWithChildren,
  AppIndexRoute: AppIndexRoute,
  AppProjectsPidRoute: AppProjectsPidRouteWithChildren,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRoute: AdminRouteWithChildren,
  AppRoute: AppRouteWithChildren,
  LoginRoute: LoginRoute,
  AuthCallbackRoute: AuthCallbackRoute,
  InviteTokenRoute: InviteTokenRoute,
  SignupPayPaymentIdRoute: SignupPayPaymentIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
